
import { Link } from 'react-router-dom';
import Navbar from "../separate/Navbar"
import $ from "jquery";
import Asset1 from "../assets/image/Asset-14x-8.png"
import Chemical1 from "../assets/image/Chemical-Industry.png"
import Electronics1 from "../assets/image/Electronics-Industry.png"
import Mechanicaz1 from "../assets/image/Mechanical-Industry.png"
import Pharmaceutical1 from "../assets/image/Pharmaceutical-Industry.png"
import Energy1 from "../assets/image/Energy-Storage.png"
import OtherApplications1 from "../assets/image/Other-Applications.png"
import React, { useEffect } from 'react';

function Isotopy() {
    useEffect(() => {
        // Scroll to the top of the page when component mounts
        window.scrollTo(0, 0);
    }, []);

    // window.onscroll = function () { scrollFunction() };

    // function scrollFunction() {
    //     if (document.body.scrollTop > 600 || document.documentElement.scrollTop > 600) {
    //         document.getElementById("navbar").style.display = "none";
    //     } else {
    //         document.getElementById("navbar").style.display = "block";
    //     }
    // }
    return (
        <div className='APP custom-isotoprnav'>

            <div className='container-fluid col-lg-12'>
                <Navbar />

                <div className='ecosystem'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='custom-gold'>
                                {/* {token ? (<a href="/buy"><button className='treasure-btn-1 active mb-3'>LEARN MORE</button></a>) : (<a href="/login"><button className='treasure-btn-1 active mb-3'>LEARN MORE</button></a>)} */}
                                <h3>THE D IQ-1 ECOSYSTEM</h3>
                                <p>Everything you need to know about the D IQ-1 CUP Token – Get your Free Booklet For know more !</p>
                                <a href="/booklist" target='_blank'><button className='treasure-btn-1 active mb-3'>View Now</button></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='custom-isotopy'>
                    <div className='custom-container'>
                        <div className='row'>
                            <div className='col-sm-12'>
                                <div className='custom-insideisotopy'>
                                    {/* <p className='text-center'>It is a mixture of natural stable isotopes of copper 63Cu and 65Cu of ultra-high chemical purity - 99.999% in the form of powder from
                                        nanoparticles of non-layered structure (spherical shape), stored in special ampoules filled with inert gas argon (see the photo of the package).</p> */}
                                    <h2>
                                        What is our asset?</h2>
                                    <p className='text-left'>D IQ-1 Stable Isotopes represent the pinnacle of strategic resources in the global race for technological advancement. Engineered as a high-purity copper material (⁶³Cu/⁶⁵Cu, 99.9996 % purity), it is a meticulously crafted asset designed to meet the demands of cutting-edge industries such as quantum computing, fusion energy systems, and aerospace. Its unique composition—ultra-high purity nanoparticles of non-layered, spherical structure—combined with Alphanis’ proprietary security architecture , ensures authenticity, traceability, and protection against counterfeiting.</p>
                                    <div className=''>
                                        <h2>Why is this a strategic resource?</h2>
                                        <p>Stable isotopes like D IQ-1 are the unsung pillars of modern innovation. They underpin breakthroughs in quantum sensors, radiopharmaceuticals, and high-performance magnets for renewable energy systems. For instance:</p>
                                        <ul>
                                            <li>
                                                Rare earth isotopes (e.g., neodymium, dysprosium) are critical for wind turbine magnets and laser technologies.
                                            </li>
                                            <li>
                                                Precious metal isotopes (e.g., ⁶³Cu, platinum) enable unmatched conductivity, thermal stability, and corrosion resistance in advanced electronics and aerospace components.
                                            </li>
                                            <li>
                                                ⁶⁵Cu , a cornerstone of D IQ-1 , is vital for quantum computing hardware and precision cancer therapies, where its stable, non-radioactive nature ensures safety and efficacy.
                                            </li>
                                        </ul>
                                    </div>
                                    <div className=''>
                                        <h2>Economic Imperative</h2>
                                        <p>The global shift toward decarbonization, AI-driven innovation, and quantum technologies has made stable isotopes strategic commodities . Production challenges—due to complex separation processes and limited natural abundance—drive prices to extraordinary levels, with certain isotopes reaching €5,300 per gram . This scarcity, coupled with surging demand from industries like fusion energy (where isotopes are irreplaceable for reactor components) and medical imaging (where they enable life-saving diagnostics), positions D IQ-1 as a high-value asset with inherent inflation resistance.</p>
                                    </div>
                                    <div>
                                        <h2>Market Dynamics</h2>
                                        <ul>
                                            <li>
                                                Supply Constraints : Only a handful of global facilities can produce isotopes at such purity, creating a bottleneck that amplifies their economic value.
                                            </li>
                                            <li>
                                                Demand Surge : The energy transition (e.g., fusion reactors) and AI hardware advancements (e.g., quantum processors) are structural tailwinds.
                                            </li>
                                            <li>
                                                Investment Case : As governments and corporations prioritize "tech sovereignty," strategic reserves of isotopes like D IQ-1 will mirror the importance of rare earth metals, becoming a critical hedge against technological obsolescence and supply chain risks.
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        <h2>Conclusion</h2>
                                        <p>D IQ-1 Stable Isotopes are not merely a material—they are a digital store of value for the future. Their role in enabling the next industrial revolution, paired with their astronomical per-gram pricing, underscores their status as a rare, tangible asset with asymmetric upside. For investors, this is an opportunity to stake a claim in the infrastructure of tomorrow, backed by irrefutable market fundamentals and the immutable laws of supply and demand.</p>
                                        <p>This framing positions D IQ-1 as both a technical marvel and a financial asset, appealing to sophisticated investors seeking exposure to the "building blocks of tomorrow’s technology." The emphasis on scarcity, strategic importance, and price dynamics aligns with the rigor of a financial analysis while maintaining the urgency of a market-driven narrative</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mt-lg-4'>
                            <div className='col-lg-12'>
                                <h2>What is the Application for D IQ-1 ?</h2>
                                <div className='row mt-3'>
                                    <div className='col-lg-4 '>
                                        <div className='custom-isotope-box-1'>
                                            <img src={Chemical1}></img>
                                            <h2 className='mt-2'>Electronics Industry</h2>
                                            <p>In the rapidly evolving electronics sector, the key role of D IQ-1 cannot be overstated. Its exceptional electrical conductivity makes it indispensable in developing advanced conductive inks, coatings, and components. </p>
                                        </div>
                                    </div>
                                    <div className='col-lg-4 '>
                                        <div className='custom-isotope-box-1'>
                                            <img src={Electronics1}></img>
                                            <h2 className='mt-2'>Chemical Industry</h2>
                                            <p>Acting as a catalyst, D IQ-1 accelerates various chemical processes, aligning itself with the industry's strides towards more efficient and advanced chemical production methods.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-4 '>
                                        <div className='custom-isotope-box-1'>
                                            <img src={Mechanicaz1}></img>
                                            <h2 className='mt-2'>Mechanical Industry</h2>
                                            <p>The mechanical sector benefits significantly from the inclusion of D IQ-1, especially in metallurgy and manufacturing.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-4 '>
                                        <div className='custom-isotope-box-1'>
                                            <img src={Pharmaceutical1}></img>
                                            <h2 className='mt-2'>Pharmaceutical Industry</h2>
                                            <p>Innovative applications of D IQ-1 in medicine, particularly for bone health and wound healing, are testament to its growing importance in pharmaceutical advancements.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-4 '>
                                        <div className='custom-isotope-box-1'>
                                            <img src={Energy1}></img>
                                            <h2 className='mt-2'>Energy Storage</h2>
                                            <p>Marking its territory in the energy storage domain, D IQ-1 is vital for the development of high-performance batteries and supercapacitors.
                                            </p>
                                        </div>
                                    </div>
                                    <div className='col-lg-4 '>
                                        <div className='custom-isotope-box-1'>
                                            <img src={OtherApplications1}></img>
                                            <h2 className='mt-2'>Other Applications</h2>
                                            <p>From aerospace to defense, D IQ-1 versatility shines, with its use expanding in tandem with technological advancements in these dynamic fields. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mt-lg-3'>
                            <div className='col-lg-12'>
                                <h2 className=''>What is the market growth potential for D IQ-1 in the coming years?</h2>
                                <div className='row mt-5 align-items-center justify-content-between'>
                                    <div className='col-lg-6'>
                                        <div className='custom-down-years'>
                                            <p>The D IQ-1 Market has seen rapid growth recently and is
                                                expected to continue expanding significantly from 2023 to 2028. This surge is
                                                primarily driven by rising demands in various sectors such as electronics,
                                                mechanics, and pharmaceuticals. Unique properties of D IQ-1, which allow it to replace silver in certain applications, contribute to
                                                its popularity. The Global D IQ-1 Market report offers an
                                                in-depth analysis of the market, examining key segments, trends, and
                                                influential factors shaping its growth.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-5'>
                                        <div className='custom-down-years'>
                                            <img src={Asset1}></img>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Isotopy